module.exports = require('./helpers/bundle-url').getBundleURL('gnX1Z') + "logo-dark.a922e36b.svg";